<div class="drive-shell aic-mobile-page aic-drive-page">

  <!-- DRAG & DROP OVERLAY -->
  <transition name="drop-fade">
    <div v-if="page_drag_active" class="dropzone-overlay d-flex align-items-center justify-content-center">
      <div class="dropzone-inner d-flex flex-column align-items-center">
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#C8102E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
        <p class="drop-title">DRAG & DROP</p>
        <p class="drop-sub">Files will be added to {{ current_folder }}</p>
      </div>
    </div>
  </transition>

  <Navbar />
  <Sidebar />

  <div v-if="drive_items_loading && drive_section !== 'admin'" class="loading-overlay position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
    <div class="text-center">
      <div class="custom-spinner"></div>
      <p class="mt-2 small text-muted">Loading drive items...</p>
    </div>
  </div>

  <div class="page-wrapper aic-mobile-content">
    <div class="hero-section w-100 aic-safe-bottom">
      <div class="drive-google-shell">
        <div
          v-if="mobile_drive_drawer_open"
          class="drive-mobile-scrim"
          @click="close_mobile_drive_drawer"
        ></div>

        <aside
          class="drive-view-rail d-flex flex-column gap-1"
          :class="{ 'drive-view-rail-open': mobile_drive_drawer_open }"
          aria-label="Drive sections"
        >
          <div class="drive-mobile-rail-profile d-flex align-items-center gap-3 px-3 py-3 border-bottom">
            <span class="drive-mobile-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0">{{ mobile_user_initial }}</span>
            <span class="drive-mobile-email flex-grow-1 text-truncate">{{ mobile_user_email || 'My Drive' }}</span>
            <button
              class="drive-mobile-rail-close btn p-0 ms-auto d-inline-flex align-items-center justify-content-center"
              type="button"
              title="Close Drive menu"
              @click="close_mobile_drive_drawer"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="dropdown">
            <button
              class="drive-rail-action dropdown-toggle d-flex align-items-center gap-2"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fas fa-plus"></i>
              <span>New</span>
            </button>
            <ul class="dropdown-menu drive-dropdown shadow-sm">
              <li>
                <a href="#" class="drive-dd-item d-flex align-items-center gap-2 px-3 py-2 rounded-3" @click.prevent="open_create_folder_modal">
                  <span class="ddi-icon ddi-folder d-flex align-items-center justify-content-center flex-shrink-0"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg></span>
                  Create folder
                </a>
              </li>
              <li>
                <a href="#" class="drive-dd-item d-flex align-items-center gap-2 px-3 py-2 rounded-3" @click.prevent="open_upload_modal">
                  <span class="ddi-icon ddi-upload d-flex align-items-center justify-content-center flex-shrink-0"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg></span>
                  File upload
                </a>
              </li>
              <li><hr class="dropdown-divider my-1" /></li>
              <li>
                <a href="#" class="drive-dd-item d-flex align-items-center gap-2 px-3 py-2 rounded-3" @click.prevent="open_create_doc_modal('word')">
                  <span class="ddi-icon ddi-word d-flex align-items-center justify-content-center flex-shrink-0"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg></span>
                  Word document
                </a>
              </li>
              <li>
                <a href="#" class="drive-dd-item d-flex align-items-center gap-2 px-3 py-2 rounded-3" @click.prevent="open_create_doc_modal('excel')">
                  <span class="ddi-icon ddi-xls d-flex align-items-center justify-content-center flex-shrink-0"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="3" y1="15" x2="21" y2="15"/><line x1="9" y1="3" x2="9" y2="21"/></svg></span>
                  Excel spreadsheet
                </a>
              </li>
              <li>
                <a href="#" class="drive-dd-item d-flex align-items-center gap-2 px-3 py-2 rounded-3" @click.prevent="open_create_doc_modal('powerpoint')">
                  <span class="ddi-icon ddi-ppt d-flex align-items-center justify-content-center flex-shrink-0"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg></span>
                  PowerPoint presentation
                </a>
              </li>
            </ul>
          </div>
          <button
            class="drive-rail-link d-flex align-items-center gap-2 text-start"
            :class="{ active: drive_section === 'my' }"
            type="button"
            @click="switch_drive_section('my')"
          >
            <i class="fas fa-hard-drive"></i>
            <span>My Drive</span>
          </button>
          <button
            class="drive-rail-link d-flex align-items-center gap-2 text-start"
            :class="{ active: drive_section === 'shared' }"
            type="button"
            @click="switch_drive_section('shared')"
          >
            <i class="fas fa-user-group"></i>
            <span>Shared with me</span>
          </button>
          <button
            class="drive-rail-link d-flex align-items-center gap-2 text-start"
            :class="{ active: drive_section === 'recent' }"
            type="button"
            @click="switch_drive_section('recent')"
          >
            <i class="fas fa-clock-rotate-left"></i>
            <span>Recent</span>
          </button>
          <button
            class="drive-rail-link d-flex align-items-center gap-2 text-start"
            :class="{ active: drive_section === 'starred' }"
            type="button"
            @click="switch_drive_section('starred')"
          >
            <i class="fas fa-star"></i>
            <span>Starred</span>
          </button>
          <button
            class="drive-rail-link d-flex align-items-center gap-2 text-start"
            :class="{ active: drive_section === 'trash' }"
            type="button"
            @click="switch_drive_section('trash')"
          >
            <i class="fas fa-trash"></i>
            <span>Trash</span>
          </button>

          <button
            v-if="can_view_all_drives"
            class="drive-rail-link d-flex align-items-center gap-2 text-start"
            :class="{ active: drive_section === 'admin' }"
            type="button"
            @click="switch_drive_section('admin')"
          >
            <i class="fas fa-database"></i>
            <span>All Drives</span>
          </button>

          <div class="drive-mobile-rail-footer mt-auto p-3 bg-white border rounded-3 shadow-sm">
            <div class="drive-mobile-storage-row d-flex align-items-center gap-2 fw-bold mb-2">
              <i class="fas fa-cloud"></i>
              <span>Drive storage</span>
            </div>
            <div class="drive-mobile-storage-bar progress">
              <div
                class="drive-mobile-storage-progress progress-bar"
                role="progressbar"
                :style="{ width: storage_percentage + '%' }"
                :aria-valuenow="storage_percentage"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <p class="mb-0 mt-2 text-muted">{{ storage_summary }}</p>
          </div>
        </aside>

        <section class="drive-file-surface d-flex flex-column overflow-hidden">
          <div class="drive-mobile-topbar d-flex align-items-center">
            <button
              v-if="current_folder_id || (drive_section === 'admin' && admin_selected_drive)"
              class="drive-mobile-menu-btn btn p-0 flex-shrink-0 d-inline-flex align-items-center justify-content-center"
              type="button"
              title="Back"
              @click="navigate_mobile_back"
            >
              <i class="fas fa-arrow-left"></i>
            </button>
            <button
              v-else
              class="drive-mobile-menu-btn btn p-0 flex-shrink-0 d-inline-flex align-items-center justify-content-center"
              type="button"
              title="Open Drive menu"
              @click="toggle_mobile_drive_drawer"
            >
              <i class="fas fa-bars"></i>
            </button>
            <h1 class="flex-grow-1 text-truncate mb-0">{{ mobile_drive_title }}</h1>
            <button
              class="drive-mobile-icon-btn btn p-0 flex-shrink-0 d-inline-flex align-items-center justify-content-center"
              type="button"
              title="Search Drive"
              @click="focus_mobile_drive_search"
            >
              <i class="fas fa-search"></i>
            </button>
            <button
              class="drive-mobile-icon-btn btn p-0 flex-shrink-0 d-inline-flex align-items-center justify-content-center"
              type="button"
              title="Toggle view"
              @click="view_mode = view_mode === 'grid' ? 'list' : 'grid'"
            >
              <i :class="view_mode === 'grid' ? 'fas fa-list-ul' : 'fas fa-table-cells-large'"></i>
            </button>
            <div class="drive-mobile-sort-wrap position-relative flex-shrink-0">
              <button
                class="drive-mobile-icon-btn btn p-0 d-inline-flex align-items-center justify-content-center"
                :class="{ active: mobile_sort_menu_open }"
                type="button"
                title="Sort by"
                @click.stop="toggle_mobile_sort_menu"
              >
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <div
                v-if="mobile_sort_menu_open"
                class="drive-mobile-sort-menu position-absolute bg-white border rounded-3 shadow"
                @click.stop
              >
                <p class="drive-mobile-sort-title text-uppercase fw-bold">Sort by</p>
                <button
                  v-for="option in sort_options"
                  :key="option.value"
                  class="drive-mobile-sort-item d-flex align-items-center gap-2 text-start"
                  :class="{ active: sort_by === option.value }"
                  type="button"
                  @click="set_sort_by(option.value)"
                >
                  <i :class="option.icon"></i>
                  <span class="flex-grow-1 text-truncate">{{ option.label }}</span>
                  <i v-if="sort_by === option.value" class="fas fa-check drive-mobile-sort-check ms-auto"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center gap-3 flex-wrap">

            <div class="breadcrumb-container mt-4 flex-grow-1 overflow-hidden">
              <nav aria-label="breadcrumb" class="w-100">
                <ol class="breadcrumb mb-0 flex-nowrap overflow-auto pb-1">
                  <li class="breadcrumb-item flex-shrink-0">

                    <a href="#"
                      @click.prevent="navigate_to_folder(null)"
                      class="first-breadcrumb-item text-nowrap"
                      @drop.prevent="drive_section !== 'admin' && handle_drop_on_path($event, null)"
                    >
                      <i class="fas fa-home me-1"></i>
                      {{ root_label }}
                    </a>
                  </li>
                  <li
                    v-if="drive_section === 'admin' && admin_selected_drive"
                    class="breadcrumb-item text-truncate flex-shrink-0"
                    :class="{ active: !current_folder_id }"
                  >

                    <a v-if="current_folder_id"
                      href="#"
                      @click.prevent="navigate_to_folder(null)"
                      class="first-breadcrumb-item text-truncate d-inline-block align-middle"
                    >
                      {{ admin_selected_drive.name }}
                    </a>
                    <span v-else class="second-breadcrumb-item text-truncate d-inline-block align-middle w-100">
                      {{ admin_selected_drive.name }}
                    </span>
                  </li>
                  <li
                    v-if="hidden_breadcrumb_path.length"
                    class="breadcrumb-item flex-shrink-0 drive-breadcrumb-overflow position-relative"
                  >
                    <button
                      class="drive-breadcrumb-ellipsis d-inline-flex align-items-center justify-content-center border-0 bg-transparent p-0"
                      type="button"
                      :title="hidden_breadcrumb_label"
                      :aria-expanded="breadcrumb_overflow_open"
                      @click.stop="toggle_breadcrumb_overflow"
                    >
                      ...
                    </button>
                    <div
                      v-if="breadcrumb_overflow_open"
                      class="drive-breadcrumb-menu position-absolute bg-white border rounded-3 shadow-sm"
                      @click.stop
                    >
                      <button
                        v-for="folder in hidden_breadcrumb_path"
                        :key="'hidden-crumb-' + folder.id"
                        class="drive-breadcrumb-menu-item d-flex align-items-center gap-2 w-100 border-0 bg-transparent text-start"
                        type="button"
                        :title="folder.name"
                        @click="navigate_to_folder(folder); close_breadcrumb_overflow();"
                      >
                        <i class="fas fa-folder"></i>
                        <span class="text-truncate">{{ folder.name }}</span>
                      </button>
                    </div>
                  </li>
                  <li
                    v-for="(folder, index) in visible_breadcrumb_path"
                    :key="folder.id"
                    class="breadcrumb-item text-truncate flex-shrink-0"
                    :class="{ active: index === visible_breadcrumb_path.length - 1 }"
                  >
                    <a
                      v-if="index < visible_breadcrumb_path.length - 1"
                      href="#"
                      @click.prevent="navigate_to_folder(folder)"
                      class="first-breadcrumb-item text-truncate d-inline-block align-middle"
                      :class="{ 'drag-over-path': drag_over_folder_id === folder.id }"
                      @dragover.prevent="drive_section !== 'admin' && (drag_over_folder_id = folder.id)"
                      @dragleave="drive_section !== 'admin' && (drag_over_folder_id = null)"
                      @drop.prevent="drive_section !== 'admin' && handle_drop_on_path($event, folder)"
                    >
                      {{ folder.name }}
                    </a>
                    <span v-else class="second-breadcrumb-item text-truncate d-inline-block align-middle w-100">
                      {{ folder.name }}
                    </span>
                  </li>
                </ol>
              </nav>
            </div>

            <div class="min-w-12 flex-grow-1 d-none d-md-block"></div>

            <!-- RIGHT SIDE -->
            <div class="d-flex align-items-center gap-2 mt-4 flex-shrink-0 flex-wrap justify-content-end">
              <button
                v-if="has_copied_file"
                class="btn btn-sm upload-button text-white d-inline-flex align-items-center gap-2"
                type="button"
                @click="paste_copied_file"
              >
                <i class="fas fa-paste"></i>
                <span>Paste</span>
              </button>
              <button
                v-if="has_copied_file"
                class="btn btn-sm btn-outline-dark d-inline-flex align-items-center gap-2"
                type="button"
                @click="clear_copied_file"
              >
                <i class="fas fa-xmark"></i>
                <span>Clear Copy</span>
              </button>
              <input
                class="filter-input-drive form-control form-control-sm border rounded-6 shadow-sm border-danger"
                v-model="list_search_query"
                type="text"
                title="Filter button"
                :placeholder="'Search ' + root_label"
              />
              <div v-if="drive_section !== 'admin' || admin_selected_drive" class="view-toggle btn-group d-flex" role="group">
                <button
                  class="vbtn btn btn-sm d-flex align-items-center justify-content-center"
                  :class="{ active: view_mode === 'list' }"
                  @click="view_mode = 'list'"
                  title="List view"
                  type="button"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
                </button>
                <button
                  class="vbtn btn btn-sm"
                  :class="{ active: view_mode === 'grid' }"
                  @click="view_mode = 'grid'"
                  title="Grid view"
                  type="button"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                </button>
              </div>
            </div>

          </div>

          <!-- SCROLLABLE BODY -->
          <div class="drive-scroll-body flex-grow-1 overflow-y-auto overflow-x-hidden">
            <template v-if="drive_section === 'admin' && !admin_selected_drive">

              <div v-if="admin_drives_loading" class="loading-overlay position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
                <div class="text-center">
                  <div class="custom-spinner"></div>
                  <p class="mt-2 small text-muted">Loading drives...</p>
                </div>
              </div>

              <div v-else-if="!admin_drives.length" class="text-center text-muted my-5 py-5">
                <i class="fas fa-database fs-2 mb-3 d-block opacity-25"></i>
                <p class="mb-0 fw-medium">No drives found.</p>
              </div>

              <div v-else>
                <div class="admin-drive-overview d-flex align-items-end justify-content-between gap-3 px-1 pt-3 pb-3">
                  <div>
                    <p class="section-label mb-1">All User Drives</p>
                    <h2 class="admin-drive-title mb-0">Drive directory</h2>
                  </div>
                  <div class="admin-drive-metrics d-flex align-items-center flex-wrap justify-content-end gap-2">
                    <span class="d-inline-flex align-items-center rounded-pill"><strong>{{ admin_drives_count || 0 }}</strong> drives</span>
                    <span class="d-inline-flex align-items-center rounded-pill"><strong>{{ admin_active_drives_count }}</strong> active</span>
                    <span class="d-inline-flex align-items-center rounded-pill"><strong>{{ admin_total_items_count }}</strong> items</span>
                  </div>
                </div>

                <div v-if="!admin_filtered_drives.length" class="admin-empty-filter d-flex align-items-center justify-content-center gap-2">
                  <i class="fas fa-search"></i>
                  <span>No drives match your search.</span>
                </div>

                <div v-else class="admin-drive-directory mt-2 border rounded-3 overflow-hidden">
                  <div class="admin-drive-head">
                    <span>Drive</span>
                    <span>Owner</span>
                    <span>Items</span>
                    <span></span>
                  </div>

                  <button
                    v-for="drive in admin_filtered_drives"
                    :key="drive.id"
                    class="admin-drive-row w-100 border-0"
                    type="button"
                    @click="open_admin_drive(drive)"
                  >
                    <div class="admin-drive-main d-flex align-items-center gap-3">
                      <div class="admin-drive-avatar d-flex align-items-center justify-content-center flex-shrink-0">
                        {{ admin_drive_initials(drive) }}
                      </div>
                      <div class="min-w-0">
                        <p class="admin-drive-name mb-0 text-truncate">{{ drive.name }}</p>
                        <p class="admin-drive-email mb-0 text-truncate">{{ drive.email }}</p>
                      </div>
                    </div>
                    <div class="admin-drive-owner text-truncate">
                      {{ drive.owner || '-' }}
                    </div>
                    <div>
                      <span class="admin-drive-count d-inline-flex align-items-center justify-content-center rounded-pill">
                        {{ admin_visible_item_count(drive) }} item{{ admin_visible_item_count(drive) !== 1 ? 's' : '' }}
                      </span>
                    </div>
                    <div class="admin-drive-open d-flex align-items-center justify-content-end">
                      <i class="fas fa-chevron-right"></i>
                    </div>
                  </button>
                </div>
              </div>

            </template>

            <template v-else>

              <!-- FOR YOU -->
              <div v-if="for_you_items.length" class="for-you-section">
                <p class="section-label">Suggested For You</p>
                <div class="foryou-grid">
                  <div v-for="card in for_you_items" :key="'fy-' + card.id" class="foryou-card" @click="open_item(card)">
                    <div class="d-flex align-items-start justify-content-between mb-2">
                      <div class="fyc-badge d-flex align-items-center justify-content-center flex-shrink-0 text-white" :style="{ background: file_type_color(card) }">
                        <i :class="file_icon(card)"></i>
                      </div>
                      <span class="fyc-tag badge rounded-pill fw-semibold text-nowrap">
                        {{ card.last_opened_at ? 'Opened' : 'Updated' }} {{ format_relative(card.updated_ts) }}
                      </span>
                    </div>
                    <p class="fyc-name">{{ card.name }}</p>
                    <p class="fyc-owner">Opened by {{ card.last_opened_by || card.owner || '-' }}</p>
                  </div>
                </div>
              </div>

              <div class="mb-4"></div>

              <!-- CHIP FILTERS + NEW Button -->
              <div class="drive-filter-row d-flex align-items-center flex-wrap gap-2 my-2">
                <div v-if="drive_section !== 'admin'" class="dropdown drive-mobile-new-wrap">
                  <button
                    class="chip drive-mobile-new-chip d-flex align-items-center"
                    type="button"
                    title="New"
                    :aria-expanded="mobile_new_menu_open"
                    @click.stop="toggle_mobile_new_menu"
                  >
                    <i class="fas fa-plus"></i>New
                  </button>
                </div>
                <button v-for="opt in chip_options" :key="opt.value" class="chip d-flex align-items-center" :class="{ active: fileTypeFilter === opt.value }" @click="fileTypeFilter = opt.value">
                  <i :class="opt.icon"></i>{{ opt.label }}
                </button>
                <span v-if="section_context_label" class="shared-context-pill d-flex align-items-center">
                  <i class="fas fa-circle-info"></i>
                  {{ section_context_label }}
                </span>
                <button
                  v-if="drive_section === 'trash'"
                  class="chip d-flex align-items-center text-danger"
                  type="button"
                  :disabled="empty_trash_in_progress || !trash_items.length"
                  @click="empty_trash"
                >
                  <span v-if="empty_trash_in_progress" class="spinner-border spinner-border-sm"></span>
                  <i v-else class="fas fa-trash-alt"></i>
                  Empty Trash
                </button>
                <!-- Admin read-only context label -->
                <span v-if="drive_section === 'admin' && admin_selected_drive" class="shared-context-pill d-flex align-items-center">
                  <i class="fas fa-eye me-1"></i>
                  Viewing {{ admin_selected_drive.owner }}'s drive — read only
                </span>
              </div>

              <!-- LIST VIEW -->
              <template v-if="view_mode === 'list'">
                <div class="file-list-container">
                  <div class="d-none d-md-flex align-items-center px-3 pb-2 mb-1 border-bottom file-list-head">
                    <div class="file-col-name fth">Name</div>
                    <div class="file-col-date fth">Last Opened</div>
                    <div class="file-col-owner fth">{{ list_actor_header() }}</div>
                    <div class="file-col-activity fth text-end">Activity</div>
                  </div>

                  <div v-if="filtered_items.length">
                    <div
                      v-for="file in filtered_items"
                      :key="file.id"
                      class="file-row d-flex flex-column flex-md-row align-items-start align-items-md-center px-3 py-2 rounded-3 position-relative"
                      :class="{
                        'folder-drag-over': file.type === 'folder' && drag_over_folder_id === file.id,
                        'file-row-menu-open': portal_file && portal_file.id === file.id
                      }"
                      :draggable="drive_section !== 'admin'"
                      @click="open_item(file)"
                      @dragstart="drive_section !== 'admin' && handle_drag_start($event, file)"
                      @dragend="drive_section !== 'admin' && handle_drag_end($event)"
                      @dragover="drive_section !== 'admin' && handle_drag_over($event, file)"
                      @dragleave="drive_section !== 'admin' && handle_drag_leave($event, file)"
                      @drop="drive_section !== 'admin' && handle_drop_on_folder($event, file)"
                      @mouseenter="start_preview(file)"
                      @mouseleave="cancel_preview"
                    >
                      <!-- MOBILE -->
                      <div class="w-100 d-flex d-md-none flex-column">
                        <div class="d-flex align-items-center gap-2 overflow-hidden mb-2">
                          <div
                            class="fr-icon d-flex align-items-center justify-content-center rounded-2 flex-shrink-0"
                            :style="{ background: file_icon_bg(file) }"
                          >
                            <i :class="file_icon(file)" :style="{ color: file_icon_color(file) }"></i>
                          </div>
                          <span class="fr-label fw-medium" :title="file.name">{{ file.name }}</span>
                          <span v-if="is_shared_item(file)" class="shared-badge mobile-shared-badge">
                            {{ shared_access_name(file) }}
                          </span>
                        </div>
                        <div class="d-flex flex-wrap align-items-center gap-3">
                          <div class="d-flex align-items-center w-50">
                            <span class="text-secondary small drive-col-label">Last opened:</span>
                            <span class="fr-date small">{{ file.updated_at }}</span>
                          </div>
                          <div class="d-flex align-items-center w-50">
                            <span class="text-secondary small drive-col-label">{{ item_actor_label(file) }}</span>
                            <span class="fr-owner-name small">{{ item_actor_name(file) }}</span>
                          </div>
                          <div v-if="drive_section !== 'admin'" class="d-flex align-items-center justify-content-end w-100 mt-2" @click.stop>
                            <button
                              class="fra-btn btn btn-sm d-flex align-items-center justify-content-center rounded-2 mobile-kebab-btn"
                              title="More actions"
                              @click.stop="toggle_mobile_action_menu($event, file)"
                              type="button">
                              <i class="fas fa-ellipsis-v"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- DESKTOP -->
                      <div class="w-100 d-none d-md-flex align-items-center file-list-body">
                        <div class="file-col-name d-flex align-items-center gap-2 overflow-hidden min-w-0">
                          <div
                            class="fr-icon d-flex align-items-center justify-content-center rounded-2 flex-shrink-0"
                            :style="{ background: file_icon_bg(file) }"
                          >
                            <i :class="file_icon(file)" :style="{ color: file_icon_color(file) }"></i>
                          </div>
                          <span class="fr-label text-truncate fw-medium" :title="file.name">{{ file.name }}</span>
                          <span v-if="is_shared_item(file)" class="shared-badge">
                            {{ shared_access_name(file) }}
                          </span>
                        </div>
                        <div class="file-col-date fr-date text-truncate">{{ file.updated_at }}</div>
                        <div class="file-col-owner overflow-hidden min-w-0">
                          <span class="fr-owner-name text-truncate d-block">{{ item_actor_name(file) }}</span>
                        </div>
                        <div class="file-col-activity d-none d-md-flex justify-content-end align-items-center" @click.stop>
                          <div v-if="drive_section !== 'admin'" class="gc-menu-wrap position-relative d-inline-flex align-items-center">
                            <button
                              class="gc-kebab-btn border-0 bg-transparent rounded-2 d-flex align-items-center justify-content-center flex-shrink-0"
                              :class="{ 'gc-kebab-active': portal_file && portal_file.id === file.id }"
                              @click.stop="toggle_mobile_action_menu($event, file)"
                              type="button"
                              title="More actions"
                            >
                              <i class="fas fa-ellipsis-v"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-else class="text-center text-muted my-5">
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="mb-3 text-secondary"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
                    <p class="mb-1">{{ empty_state_title }}</p>
                    <p class="mb-0 text-muted" v-if="empty_state_subtitle">{{ empty_state_subtitle }}</p>
                  </div>
                </div>
              </template>

              <!-- GRID VIEW -->
              <template v-else>
                <div v-if="filtered_items.length" class="file-grid">
                  <div
                    v-for="file in filtered_items"
                    :key="'g-' + file.id"
                    class="grid-card"
                    :class="{ 'grid-card-menu-open': portal_file && portal_file.id === file.id }"
                    :draggable="drive_section !== 'admin'"
                    @click="open_item(file)"
                    @dragstart="drive_section !== 'admin' && handle_drag_start($event, file)"
                    @dragend="drive_section !== 'admin' && handle_drag_end($event)"
                    @dragover="drive_section !== 'admin' && handle_drag_over($event, file)"
                    @dragleave="drive_section !== 'admin' && handle_drag_leave($event, file)"
                    @drop="drive_section !== 'admin' && handle_drop_on_folder($event, file)"
                    @mouseenter="start_preview(file)"
                    @mouseleave="cancel_preview"
                  >
                    <div class="gc-thumb d-flex align-items-center justify-content-center" :style="{ background: file_icon_bg(file) }">
                      <i :class="file_icon(file, true)" :style="{ color: file_icon_color(file) }"></i>
                    </div>
                    <div class="gc-info">
                      <div class="gc-title-row d-flex align-items-start gap-2">
                        <p class="gc-name flex-grow-1" :title="file.name">{{ file.name }}</p>
                        <span v-if="is_shared_item(file)" class="shared-badge grid-shared-badge">
                          {{ shared_access_name(file) }}
                        </span>
                      </div>
                      <p class="gc-meta">
                        {{ item_grid_meta(file) }}
                      </p>
                    </div>
                    <!-- Hide kebab in admin view — read only -->
                    <div v-if="drive_section !== 'admin'" class="gc-actions" @click.stop>
                      <div class="gc-menu-wrap position-relative d-inline-flex align-items-center">
                        <button
                          class="gc-kebab-btn border-0 bg-transparent rounded-2 d-flex align-items-center justify-content-center flex-shrink-0"
                          :class="{ 'gc-kebab-active': portal_file && portal_file.id === file.id }"
                          @click.stop="toggle_mobile_action_menu($event, file)"
                          type="button"
                          title="More actions"
                        >
                          <i class="fas fa-ellipsis-v"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="empty-state">
                  <p>{{ empty_state_title }}</p>
                </div>
              </template>

            </template>
            <!-- ═══ END normal view ═══ -->

          </div>
        </section>
      </div>
    </div>
  </div>

  <Teleport to="body">
    <ul
      v-if="mobile_new_menu_open"
      class="dropdown-menu drive-dropdown drive-mobile-new-menu shadow-sm show"
      :style="mobile_new_menu_style"
      @click.stop
    >
      <li>
        <a href="#" class="drive-dd-item d-flex align-items-center gap-2 px-3 py-2 rounded-3" @click.prevent="open_create_folder_modal(); close_mobile_new_menu()">
          <span class="ddi-icon ddi-folder d-flex align-items-center justify-content-center flex-shrink-0"><i class="fas fa-folder"></i></span>
          Create folder
        </a>
      </li>
      <li>
        <a href="#" class="drive-dd-item d-flex align-items-center gap-2 px-3 py-2 rounded-3" @click.prevent="open_upload_modal(); close_mobile_new_menu()">
          <span class="ddi-icon ddi-upload d-flex align-items-center justify-content-center flex-shrink-0"><i class="fas fa-cloud-arrow-up"></i></span>
          File upload
        </a>
      </li>
      <li><hr class="dropdown-divider my-1" /></li>
      <li>
        <a href="#" class="drive-dd-item d-flex align-items-center gap-2 px-3 py-2 rounded-3" @click.prevent="open_create_doc_modal('word'); close_mobile_new_menu()">
          <span class="ddi-icon ddi-word d-flex align-items-center justify-content-center flex-shrink-0"><i class="far fa-file-word"></i></span>
          Word document
        </a>
      </li>
      <li>
        <a href="#" class="drive-dd-item d-flex align-items-center gap-2 px-3 py-2 rounded-3" @click.prevent="open_create_doc_modal('excel'); close_mobile_new_menu()">
          <span class="ddi-icon ddi-xls d-flex align-items-center justify-content-center flex-shrink-0"><i class="far fa-file-excel"></i></span>
          Excel spreadsheet
        </a>
      </li>
      <li>
        <a href="#" class="drive-dd-item d-flex align-items-center gap-2 px-3 py-2 rounded-3" @click.prevent="open_create_doc_modal('powerpoint'); close_mobile_new_menu()">
          <span class="ddi-icon ddi-ppt d-flex align-items-center justify-content-center flex-shrink-0"><i class="far fa-file-powerpoint"></i></span>
          PowerPoint presentation
        </a>
      </li>
    </ul>

    <div
      v-if="portal_file"
      ref="actionMenu"
      class="gc-dropdown gc-portal-menu"
      :style="portal_style"
      @pointerdown.stop
      @mousedown.stop
      @click.stop
      @wheel.stop
    >
      <div class="gc-menu-header d-flex align-items-center gap-2">
        <span
          class="gc-menu-file-icon d-inline-flex align-items-center justify-content-center flex-shrink-0"
          :style="{ background: file_icon_bg(portal_file) }"
        >
          <i :class="file_icon(portal_file)" :style="{ color: file_icon_color(portal_file) }"></i>
        </span>
        <span class="gc-menu-file-name text-truncate">{{ portal_file.name }}</span>
      </div>

      <div
        v-if="!is_folder(portal_file) && !is_trashed_item(portal_file)"
        class="gc-menu-group"
      >
        <button
          class="gc-drop-item d-flex align-items-center w-100 border-0 bg-transparent text-start"
          @click.stop="preview_file(portal_file); close_mobile_action_menu()"
          type="button"
        >
          <i class="far fa-eye text-center flex-shrink-0"></i><span>Preview</span>
        </button>
      </div>

      <div
        v-if="(can_share_file(portal_file) && !is_trashed_item(portal_file)) || (drive_section !== 'shared' && can_copy_file(portal_file))"
        class="gc-menu-group"
      >
        <button
          v-if="can_share_file(portal_file) && !is_trashed_item(portal_file)"
          class="gc-drop-item d-flex align-items-center w-100 border-0 bg-transparent text-start"
          @click.stop="share_to_user(portal_file); close_mobile_action_menu()"
          type="button"
        >
          <i class="fas fa-user-plus"></i><span>Share</span>
        </button>
        <button
          v-if="drive_section !== 'shared' && can_copy_file(portal_file)"
          class="gc-drop-item d-flex align-items-center w-100 border-0 bg-transparent text-start"
          @click.stop="copy_file(portal_file)"
          type="button"
        >
          <i class="far fa-copy"></i><span>Make a copy</span>
        </button>
      </div>

      <div v-if="!is_trashed_item(portal_file)" class="gc-menu-group">
        <button
          class="gc-drop-item d-flex align-items-center w-100 border-0 bg-transparent text-start"
          @click.stop="toggle_starred_item(portal_file)"
          type="button"
        >
          <i :class="is_starred_item(portal_file) ? 'fas fa-star' : 'far fa-star'"></i>
          <span>{{ is_starred_item(portal_file) ? 'Remove from Starred' : 'Add to Starred' }}</span>
        </button>
        <button
          v-if="can_delete_file(portal_file)"
          class="gc-drop-item d-flex align-items-center w-100 border-0 bg-transparent text-start"
          @click.stop="open_rename_modal(portal_file); close_mobile_action_menu()"
          type="button"
        >
          <i class="fas fa-pen"></i><span>Rename</span>
        </button>
        <button
          v-if="can_transfer_ownership(portal_file)"
          class="gc-drop-item d-flex align-items-center w-100 border-0 bg-transparent text-start"
          @click.stop="open_transfer_ownership_modal(portal_file); close_mobile_action_menu()"
          type="button"
        >
          <i class="fas fa-user-check"></i><span>Transfer ownership</span>
        </button>
      </div>

      <div class="gc-menu-group">
        <button
          class="gc-drop-item d-flex align-items-center w-100 border-0 bg-transparent text-start"
          @click.stop="open_details_panel(portal_file)"
          type="button"
        >
          <i class="fas fa-circle-info"></i><span>File information</span>
        </button>
        <button
          v-if="is_trashed_item(portal_file) && can_delete_file(portal_file)"
          class="gc-drop-item d-flex align-items-center w-100 border-0 bg-transparent text-start"
          @click.stop="restore_drive_item(portal_file)"
          type="button"
        >
          <i class="fas fa-trash-arrow-up"></i><span>Restore</span>
        </button>
      </div>

      <div v-if="can_delete_file(portal_file)" class="gc-menu-group gc-menu-danger-group">
        <button
          class="gc-drop-item d-flex align-items-center w-100 border-0 bg-transparent text-start gc-drop-danger"
          @click.stop="open_delete_confirm(portal_file); close_mobile_action_menu()"
          type="button"
        >
          <i class="fas fa-trash"></i><span>{{ is_trashed_item(portal_file) ? 'Delete forever' : 'Move to trash' }}</span>
        </button>
      </div>
    </div>

    <div
      v-if="details_file"
      class="drive-details-scrim"
      @click="close_details_panel"
    ></div>
    <aside
      v-if="details_file"
      class="drive-details-panel"
      aria-label="File details"
      @click.stop
    >
      <div class="drive-details-header d-flex align-items-start gap-3">
        <div
          class="drive-details-icon d-flex align-items-center justify-content-center flex-shrink-0"
          :style="{ background: file_icon_bg(details_file) }"
        >
          <i :class="file_icon(details_file)" :style="{ color: file_icon_color(details_file) }"></i>
        </div>
        <div class="flex-grow-1 min-w-0">
          <p class="drive-details-kicker mb-1">{{ is_folder(details_file) ? 'Folder details' : 'File details' }}</p>
          <h2 class="drive-details-title text-truncate mb-0">{{ details_file.name }}</h2>
        </div>
        <button
          class="drive-details-close btn p-0 d-inline-flex align-items-center justify-content-center flex-shrink-0"
          type="button"
          title="Close details"
          @click="close_details_panel"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="drive-details-body">
        <section class="drive-details-section">
          <h3 class="mb-3">Information</h3>
          <dl class="drive-info-list mb-0">
            <template v-for="row in item_detail_rows(details_file)" :key="row.label">
              <dt>{{ row.label }}</dt>
              <dd class="text-truncate">{{ row.value }}</dd>
            </template>
          </dl>
        </section>

        <section class="drive-details-section">
          <h3 class="mb-2">Manage people with access</h3>
          <p class="drive-details-access-summary mb-3">{{ details_access_label(details_file) }}</p>

          <div class="drive-access-list d-flex flex-column">
            <div class="drive-access-person d-flex align-items-center gap-3">
              <span class="drive-access-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0">
                {{ owner_initials(item_owner_name(details_file)) }}
              </span>
              <div class="flex-grow-1 min-w-0">
                <p class="mb-0 fw-semibold text-truncate">{{ item_owner_name(details_file) }}</p>
                <small v-if="details_owner_email(details_file)" class="text-muted text-truncate d-block">{{ details_owner_email(details_file) }}</small>
              </div>
              <span class="badge rounded-pill bg-dark text-white flex-shrink-0">Owner</span>
            </div>

            <div v-if="details_loading_shared_with" class="drive-access-loading text-muted small d-flex align-items-center gap-2">
              <span class="spinner-border spinner-border-sm"></span>
              Loading people with access...
            </div>

            <template v-else-if="details_shared_with_list.length">
              <div
                v-for="collab in details_shared_with_list"
                :key="'details-collab-' + details_collab_user_id(collab)"
                class="drive-access-person d-flex align-items-center gap-3"
              >
                <span class="drive-access-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0">
                  {{ owner_initials(details_collab_name(collab)) }}
                </span>
                <div class="flex-grow-1 min-w-0">
                  <p class="mb-0 fw-semibold text-truncate">{{ details_collab_name(collab) }}</p>
                  <small class="text-muted text-truncate d-block">{{ details_collab_email(collab) }}</small>
                  <small class="text-muted text-truncate d-block">{{ details_collab_source(collab) }}</small>
                </div>
                <span
                  class="badge rounded-pill flex-shrink-0 small"
                  :class="details_access_badge_class(details_collab_access_level(collab))"
                >
                  {{ details_collab_access_level(collab) }}
                </span>
                <button
                  v-if="can_remove_details_access(collab)"
                  class="btn btn-sm btn-outline-danger flex-shrink-0 d-flex align-items-center justify-content-center btn-icon-sm"
                  type="button"
                  title="Remove access"
                  :disabled="revoking_user_id === details_collab_user_id(collab)"
                  @click.stop="remove_details_user_access(collab)"
                >
                  <span v-if="revoking_user_id === details_collab_user_id(collab)" class="spinner-border spinner-border-sm"></span>
                  <i v-else class="fas fa-times text-2xs"></i>
                </button>
              </div>
            </template>

            <div v-if="details_file.share_link || details_file.link_access_level" class="drive-access-person d-flex align-items-center gap-3">
              <span class="drive-access-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0">
                <i class="fas fa-link"></i>
              </span>
              <div class="flex-grow-1 min-w-0">
                <p class="mb-0 fw-semibold text-truncate">Anyone with the link</p>
                <small class="text-muted">{{ details_file.link_access_level?.name || details_file.link_access_level || 'Link access' }}</small>
              </div>
            </div>
          </div>
        </section>
      </div>
    </aside>
  </Teleport>

  <!-- ═══════════════════════════════════════════════
        MODALS
  ════════════════════════════════════════════════ -->

  <!-- CREATE FOLDER MODAL -->
  <div class="modal fade" id="create_folder_modal" tabindex="-1" aria-labelledby="createFolderModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-bottom-0 pb-0 mb-2">
          <h5 class="modal-title fw-bold gradient-text" id="createFolderModalLabel">Create Folder</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pt-0">
          <input type="text" class="form-control" v-model="new_folder_name" placeholder="Enter folder name" @keyup.enter="create_folder_from_modal" />
        </div>
        <div class="modal-footer border-top-0 pt-0 justify-content-end">
          <button type="button" class="btn upload-button text-white" @click="create_folder_from_modal" :disabled="uploading_in_progress">
            <span v-if="uploading_in_progress" class="spinner-border spinner-border-sm"></span>
            <span>{{ uploading_in_progress ? 'Creating...' : 'Create' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- UPLOAD FILES MODAL -->
  <div class="modal fade" id="upload_files_modal" tabindex="-1" aria-labelledby="uploadFilesModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-bottom-0 pb-0 mb-2">
          <h5 class="modal-title fw-bold gradient-text" id="uploadFilesModalLabel">Upload Files</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pt-0">
          <label for="drive_file_input" class="upload-box d-flex flex-column align-items-center justify-content-center p-5 border border-2 border-dashed rounded-3 w-100"
            @dragover.prevent="drag_over = true" @dragleave.prevent="drag_over = false" @drop.prevent="handle_drop">
            <div class="mb-2"><i class="fa-solid fa-cloud-arrow-up fs-1 text-secondary"></i></div>
            <span class="fw-semibold">Click or drag file to this area to upload</span>
            <input type="file" id="drive_file_input" class="d-none" multiple @change="handle_file_select" />
          </label>
          <div v-if="uploads.length" class="mt-3 w-100">
            <div v-for="(file, index) in uploads" :key="index" class="d-flex align-items-center mb-2 px-3 overflow-hidden">
              <i class="fas fa-file-alt me-2 text-secondary"></i>
              <span class="text-truncate min-w-0">{{ file.name }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer border-top-0 pt-0 justify-content-end">
          <button type="button" class="btn upload-button text-white" @click="upload_files_from_modal" :disabled="uploading_in_progress">
            <span v-if="uploading_in_progress" class="spinner-border spinner-border-sm"></span>
            <span>{{ uploading_in_progress ? 'Uploading...' : 'Upload' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- CREATE DOC MODAL -->
  <div class="modal fade" id="create_doc_modal" tabindex="-1" aria-labelledby="createDocModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-bottom-0 pb-0 mb-2">
          <h5 class="modal-title fw-bold gradient-text" id="createDocModalLabel">Name your file</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pt-0">
          <input type="text" class="form-control" v-model="new_doc_title" :placeholder="create_doc_placeholder" @keyup.enter="confirm_create_doc" />
        </div>
        <div class="modal-footer border-top-0 pt-0 justify-content-end">
          <button type="button" class="btn upload-button text-white" @click="confirm_create_doc" :disabled="uploading_in_progress">
            <span v-if="uploading_in_progress" class="spinner-border spinner-border-sm"></span>
            <span>{{ uploading_in_progress ? 'Creating...' : 'Create' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="preview_modal" @click.self="close_the_file_preview">
    <FilePreviewComponent
      :presigned_url="preview_file_url"
      :file_name="preview_file_name"
      :shared_access_level="preview_file_access_level"
      @close="close_the_file_preview"
      @open-office-file="open_in_office(selected_preview_file)"
    />
  </div>

  <!-- SHARE USER MODAL -->
  <div class="modal fade" id="share_user_modal" tabindex="-1" aria-labelledby="shareUserModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
      <div class="modal-content modern-modal-content">

        <div class="modal-header">
          <h5 class="modal-title gradient-text" id="shareUserModalLabel">
            Share {{ share_item_label }}
            <span v-if="share_file" class="text-muted fw-normal ms-1 small">"{{ share_file.name }}"</span>
          </h5>
          <button type="button" class="btn-close" @click="close_share_user_modal"></button>
        </div>

        <div class="modal-body modern-modal-body p-0">

          <div v-if="share_file && is_folder(share_file)" class="alert alert-warning border-0 rounded-0 d-flex align-items-start gap-2 mb-0 px-4 py-3">
            <i class="fas fa-folder-open mt-1 flex-shrink-0"></i>
            <span class="small">Sharing this folder will also give access to <strong>all files and subfolders inside it</strong>, including any new items added later.</span>
          </div>

          <div class="px-4 py-3">
            <div class="mb-3">
              <label class="fw-semibold small text-muted text-uppercase mb-2 d-block text-tracked">Step 1: Choose access level</label>
              <select class="form-select" v-model="user_access_level">
                <option disabled value="">Choose access level</option>
                <option v-for="level in access_levels" :key="level.id" :value="level.id">{{ level.name }}</option>
              </select>
            </div>

            <label class="fw-semibold small text-muted text-uppercase mb-2 d-block text-tracked">Step 2: Search for or select users to share with</label>
            <div class="share-input-group d-flex align-items-center gap-2 mb-3 p-2 border rounded-3 focus-within-ring">
              <div class="position-relative flex-grow-1">
                <i class="fas fa-user-plus position-absolute top-50 start-0 translate-middle-y text-muted ms-3"></i>
                <input type="text" class="form-control border-0 ps-5 shadow-none"
                  placeholder="Search for or select users to share with"
                  v-model="user_search_query"
                  @input="filter_users" />
              </div>
            </div>

            <div class="modern-user-list mb-3">
              <div v-if="loading_users" class="text-center text-muted py-4">
                <span class="spinner-border spinner-border-sm me-2"></span>Loading users...
              </div>
              <div v-else-if="filtered_available_users.length === 0" class="text-center text-muted py-4">
                <i class="fas fa-user-slash mb-2 d-block fs-5"></i>
                <p class="mb-0 small">No users found</p>
              </div>
              <div v-else
                v-for="user in filtered_available_users"
                :key="user.id"
                class="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 p-3 mb-2 modern-user-card"
                :class="{ 'selected': is_user_selected(user.id) }"
                @click="toggle_user_selection(user)"
              >
                <div class="position-relative flex-shrink-0">
                  <div class="modern-avatar">
                    {{ user.name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) }}
                  </div>
                  <div v-if="is_user_selected(user.id)" class="check-badge">
                    <i class="fas fa-check text-white"></i>
                  </div>
                </div>
                <div class="flex-grow-1 min-w-0">
                  <div class="fw-semibold text-truncate">{{ user.name }}</div>
                  <div class="text-muted small text-truncate">{{ user.email }}</div>
                </div>
                <span class="badge bg-secondary text-light small px-3 py-1 rounded-pill text-nowrap flex-shrink-0">{{ user.role }}</span>
              </div>
            </div>

            <div v-if="selected_share_users.length" class="selected-users-bar d-flex align-items-center gap-2 flex-wrap p-2 rounded-3 mb-3 bg-light border">
              <span class="small text-muted me-1 flex-shrink-0">Sharing with:</span>
              <span
                v-for="u in selected_share_users"
                :key="'sel-' + u.id"
                class="badge rounded-pill bg-danger text-white d-flex align-items-center gap-1 share-user-pill"
              >
                {{ u.name }}
                <button type="button" class="btn-close btn-close-white btn-close-xs ms-1" @click.stop="toggle_user_selection(u)" aria-label="Remove"></button>
              </span>
            </div>

            <div class="border-top pt-3">
              <p class="fw-semibold small text-muted text-uppercase mb-2 text-tracked">Step 3: Review share</p>
              <p class="text-muted small mb-0">
                {{ selected_share_users.length || 0 }} recipient(s) selected
                <span v-if="user_access_level_name">as {{ user_access_level_name }}</span>.
              </p>
            </div>
          </div>

        </div>

        <div class="modal-footer border-top py-2">
          <button
            class="btn cta-button text-white"
            @click="handle_share_with_users"
            :disabled="selected_share_users.length === 0 || !user_access_level || sharing_in_progress || loading_users"
          >
            <span v-if="sharing_in_progress" class="spinner-border spinner-border-sm me-1"></span>
            <i v-else class="fas fa-share-alt me-1"></i>
            {{ sharing_in_progress ? 'Sharing...' : 'Share' }}
          </button>
        </div>

      </div>
    </div>
  </div>

  <!-- OFFICE EDITOR MODAL -->
  <div class="modal fade" id="office_modal" tabindex="-1" aria-labelledby="officeModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title" id="officeModalLabel">
            <i class="far fa-file-alt me-2"></i>{{ office_file_name }}
          </span>
          <button type="button" class="btn-close" @click="close_office_modal"></button>
        </div>
        <div class="modal-body p-0 position-relative">
          <div v-if="office_loading" class="office-loading">
            <div class="office-spinner"></div>
            <p>Loading editor...</p>
          </div>
          <iframe
            v-if="office_editor_url"
            :src="office_editor_url"
            class="office-iframe"
            :class="{ 'office-iframe-ready': !office_loading }"
            @load="office_loading = false"
            allow="fullscreen; clipboard-read; clipboard-write"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>

  <!-- RENAME MODAL -->
  <div class="modal fade" id="rename_item_modal" tabindex="-1" aria-labelledby="renameItemModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-bottom-0 pb-0 mb-2">
          <h5 class="modal-title fw-bold gradient-text" id="renameItemModalLabel">Rename</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body pt-0">
          <input type="text" class="form-control" v-model="rename_new_name" placeholder="Enter new name" @keyup.enter="confirm_rename" />
        </div>
        <div class="modal-footer border-top-0 pt-0 justify-content-end">
          <button type="button" class="btn upload-button text-white" @click="confirm_rename" :disabled="rename_in_progress">
            <span v-if="rename_in_progress" class="spinner-border spinner-border-sm"></span>
            <span>{{ rename_in_progress ? 'Saving...' : 'Save' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- TRANSFER OWNERSHIP MODAL -->
  <div class="modal fade" id="transfer_ownership_modal" tabindex="-1"
       aria-labelledby="transferOwnershipModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
      <div class="modal-content">
 
        <!-- Modal Header -->
        <div class="modal-header border-bottom-0 pb-0 mb-2">
          <h5 class="modal-title fw-bold gradient-text" id="transferOwnershipModalLabel">
            Transfer Ownership:
            <span v-if="transfer_item" class="text-dark fw-semibold ms-1">
              {{ transfer_item.name }}
            </span>
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
 
        <div class="modal-body pt-0">

          <!-- Warning -->
          <div class="alert alert-warning border-0 d-flex align-items-start gap-2 mb-3">
            <i class="fas fa-triangle-exclamation mt-1 flex-shrink-0"></i>
            <span class="small">
              Once transferred, you will <strong>lose ownership</strong> of this item.
              You will retain <strong>Editor</strong> access so you can continue working with it.
            </span>
          </div>
 
          <!-- Search / filter users -->
          <input
            v-model="transfer_user_query"
            type="text"
            class="form-control mb-3"
            placeholder="Search by name or email…"
            @input="filter_transfer_users"
          />
 
          <!-- User list -->
          <div class="modern-user-list">
            <div v-if="loading_users" class="text-center text-muted py-4">
              <span class="spinner-border spinner-border-sm me-2"></span>Loading users…
            </div>
            <div v-else-if="filtered_transfer_users.length === 0" class="text-center text-muted py-4">
              <i class="fas fa-user-slash mb-2 d-block fs-5"></i>
              <p class="mb-0 small">No users found</p>
            </div>
            <div
              v-else
              v-for="user in filtered_transfer_users"
              :key="'to-' + user.id"
              class="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 p-3 mb-2 modern-user-card"
              :class="{ selected: transfer_target_user_id === user.id }"
              @click="transfer_target_user_id = user.id"
            >
              <div class="position-relative flex-shrink-0">
                <div class="modern-avatar">
                  {{ user.name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2) }}
                </div>
                <div v-if="transfer_target_user_id === user.id" class="check-badge">
                  <i class="fas fa-check text-white"></i>
                </div>
              </div>
              <div class="flex-grow-1 min-w-0">
                <div class="fw-semibold text-truncate">{{ user.name }}</div>
                <div class="text-muted small text-truncate">{{ user.email }}</div>
              </div>
              <span class="badge bg-secondary text-light small px-3 py-1 rounded-pill text-nowrap flex-shrink-0">
                {{ user.role }}
              </span>
            </div>
          </div>
 
        </div>
 
        <div class="modal-footer border-top-0 pt-0 justify-content-end">
          <button
            type="button"
            class="btn upload-button text-white"
            @click="confirm_transfer_ownership"
            :disabled="!transfer_target_user_id || transfer_in_progress"
          >
            <span v-if="transfer_in_progress" class="spinner-border spinner-border-sm me-1"></span>
            <span>{{ transfer_in_progress ? 'Transferring…' : 'Transfer ownership' }}</span>
          </button>
        </div>
 
      </div>
    </div>
  </div>

</div>
